import React from 'react'
import { isMobile, isTablet } from "react-device-detect";
import PropTypes from 'prop-types';

const Video = props => {

    const { urlEspecialVideos, slug } = props;
    var width = '100%';
    var height = 400;

    if(isMobile){
        height = 220;
    }
    if(isTablet){
        height = 350;
    }

    return (
        <article className="position-relative my-0 mx-auto text-center"
            dangerouslySetInnerHTML={{ __html: `<iframe width="${width}" height="${height}" src='${urlEspecialVideos}video/${slug}.html' />` }} 
        />
    )
}

export default Video;

Video.propTypes = {
    slug: PropTypes.string.isRequired,
    urlEspecialVideos: PropTypes.string.isRequired
}